export default "__VITE_ASSET__CxSS7p7F__"